<template>
    <div class="bb-dialog-mask" v-show="show">
        <div class="bb-dialog-wrapper">
            <form class="bb-dialog-container" @submit.prevent="onSubmit">
                <div class="bb-dialog-header">
                    <a class="bb-dialog-close" href="javascript:" @click="onClose">
                        <i class="fas fa-times"></i>
                    </a>
                    <h3>{{ title }}</h3>
                </div>
                <div class="bb-dialog-body">
                    <slot name="error"></slot>
                    <div class="mt-4 text-center">
                        <h6>{{ message }}</h6>
                    </div>
                </div>
                <div class="bb-dialog-footer">
                    <div class="mt-4 d-flex justify-content-center">
                        <button class="btn btn-secondary btn-lg" @click="() => onOK(false)">Hủy bỏ</button>
                        <button class="btn btn-warning btn-lg" @click="() => onOK(true)">Ok</button>
                    </div>
                </div>

                <div class="bb-dialog-loading" v-if="loading">
                    <div class="bb-loading mini"></div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Modal from './Modal';
export default {
    name: 'ConfirmDialog',
    components: {
        Modal,
    },
    data() {
        return {
            show: false,
        }
    },
    mounted() {
        this.show = true;
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Alert',
        },
        message: {
            type: String,
            default: 'Are you sure?',
        },
        onDone: {
            type: Function,
            default: () => null
        },
        onClose: {
            type: Function,
            default: () => null
        },
    },
    methods: {
        onOK(ok = false) {
            this.show = false;
            this.onDone(ok);
            setTimeout(() => {
                this.onClose();
            }, 500)
        }
    }
}
</script>

<style scoped>

</style>
